import {
  CheckBox,
  LinearScale,
  QuestionAnswer,
  RadioButtonChecked,
  TextFieldsOutlined,
} from '@mui/icons-material';

export interface Quiz {
  questions: Question[];
}

export type QuestionType = 'text' | 'multipleChoice' | 'singleChoice' | 'open' | 'range';

export interface BaseQuestion {
  id: string;
  type: QuestionType;
  question: string;
  config?: Record<string, unknown>;
  options?: unknown;
}

export interface TextQuestion extends BaseQuestion {
  type: 'text';
}

export interface OpenQuestion extends BaseQuestion {
  type: 'open';
}

export interface SingleChoiceQuestion extends BaseQuestion {
  type: 'singleChoice';
  options: string[];
}

export interface MultipleChoiceQuestion extends BaseQuestion {
  type: 'multipleChoice';
  options: string[];
  config: {
    countSelected?: boolean;
  };
}

export interface RangeQuestion extends BaseQuestion {
  type: 'range';
  options: {
    min: string;
    max: string;
    step: string;
  };
}

export type Question =
  | TextQuestion
  | OpenQuestion
  | SingleChoiceQuestion
  | MultipleChoiceQuestion
  | RangeQuestion;
export type ChoiceQuestion = MultipleChoiceQuestion | SingleChoiceQuestion;

export interface UserResponses {
  responses: Response[];
  analysis?: string;
}

export interface Response {
  questionId: string;
  answer: string | string[];
}

export const QUIZ_DATA_INITIAL_VALUE: Quiz = {
  questions: [],
};

export const USER_RESPONSES_INITIAL_VALUE: UserResponses = {
  responses: [],
};

export const typeDetails: Record<Question['type'], { label: string; Icon: React.FC }> = {
  text: {
    label: 'Texto',
    Icon: TextFieldsOutlined,
  },
  multipleChoice: {
    label: 'Opción multiple',
    Icon: CheckBox,
  },
  singleChoice: {
    label: 'Opción única',
    Icon: RadioButtonChecked,
  },
  open: {
    label: 'Pregunta abierta',
    Icon: QuestionAnswer,
  },
  range: {
    label: 'Rango',
    Icon: LinearScale,
  },
};

export const isChoiceQuestion = (type: Question['type']): type is ChoiceQuestion['type'] => {
  return type === 'multipleChoice' || type === 'singleChoice';
};
